var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductIconTrue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.598 5.999c-4.228 2.594-7.294 5.87-8.678 7.51l-3.38-2.65-1.495 1.204 5.834 5.939c1.002-2.573 4.187-7.601 8.074-11.175l-.355-.828z",
    fill: "#5FC475"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4LjU5ODMgNS45OTkwMkMxNC4zNzAzIDguNTkyODcgMTEuMzAzNSAxMS44NjgyIDkuOTE5NjkgMTMuNTA5NEw2LjU0MDA0IDEwLjg1OTlMNS4wNDQ5MiAxMi4wNjI5TDEwLjg3OTMgMTguMDAxN0MxMS44ODA3IDE1LjQyODcgMTUuMDY1NyAxMC40MDA5IDE4Ljk1MyA2LjgyNjU1TDE4LjU5ODMgNS45OTkwMloiIGZpbGw9IiM1RkM0NzUiLz4KPC9zdmc+Cg==";
export { SvgProductIconTrue as ReactComponent };